import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class PaymentValidators {
  static nameOnly(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      let valid = /^[a-zA-Z\s+_-]*$/.test(value);

      if (value.length < 3) {
        valid = false;
      }

      return valid ? null : { invalidCardHolder: true };
    };
  }

  static validCardNumber(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      const valid = value.length === 19;
      return valid ? null : { invalidCardNumber: true };
    };
  }

  static validDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;

      if (!value) return null;

      if (!value.includes('/') || value.length !== 5) {
        return { invalidDate: true };
      }

      const [monthStr, yearStr] = value.split('/');
      const expMonth = parseInt(monthStr, 10);
      const expYear = 2000 + parseInt(yearStr, 10);

      if (isNaN(expMonth) || isNaN(expYear) || expMonth < 1 || expMonth > 12) {
        return { invalidMonth: true };
      }

      const now = new Date();
      const currentYear = now.getFullYear();
      const currentMonth = now.getMonth() + 1;

      if (expYear < currentYear || (expYear === currentYear && expMonth < currentMonth)) {
        return { expired: true };
      }

      return null;
    };
  }

  static validCVV(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;

      const valid = value.length === 3;
      return valid ? null : { invalidCVV: true };
    };
  }
}
